import { IHexGridData, IGameData } from 'js/bubbleCore/types';
import { Bubble } from 'js/bubbleCore/bubbles/types';
import { isInGrid } from 'js/bubbleCore/utils/isInGrid';
import { IPoint } from 'framework/utils/math-utils';
import { getGridValue } from 'js/bubbleCore/utils/getGridValue';
import { getNeighbours} from 'js/bubbleCore/utils/getNeighbours';
import { filterGrid } from 'js/bubbleCore/utils/filterGrid';
import { IEvent, createBubbleUpdatedEvent } from 'js/bubbleCore/events';
import { transferBubble } from 'js/bubbleCore/handlers/transferBubble';
import { popOutBubble } from 'js/bubbleCore/bubbles/behavior/popOutBubble';
import { BubbleGameBoard } from 'js/bubbleCore/BubbleGameBoard';

export function popOutUnhookedBubbles(board: BubbleGameBoard): void {
  const data = board.getData();
  getUnhookedBubbles(data.grid)
    .forEach((bubble) => {
      popOutBubble(board, bubble);
    });
}

export function getUnhookedBubbles(grid: IHexGridData<Bubble>): Bubble[] {
  const safeBubbles: Bubble[] = getHooks(grid)
    .map(({x, y}) => getGridValue(grid, x, y))
    .filter(Boolean) as Bubble[];

  for (const bubble of safeBubbles) {
    safeBubbles.push(
      ...getNeighbours(grid, bubble.col, bubble.row)
        .filter((bubble) => !safeBubbles.includes(bubble))
    );
  }

  return filterGrid(grid, (bubble) => !safeBubbles.includes(bubble));
}

function getHooks<T>(grid: IHexGridData<T>): IPoint[] {
  const hooks: IPoint[] = [];
  const row = grid.limits.y;
  for (let col = 0; col < grid.limits.width; col++) {
    const value = getGridValue(grid, col, row);
    if (value) hooks.push({x: col, y: row});
  }
  return hooks;
}